$(document).ready(function () {

    (function () {

        let header = $('.js-header'),
            headerBtn = $('.js-header-btn'),
            headerMenu = $('.js-header-menu'),
            btnToTop = $('.js-scroll-top'),
            windowWidth = window.innerWidth,
            bodyWidth = document.body.clientWidth,
            scrollWidth = windowWidth - bodyWidth;

        /*-----------------disable scroll of body---------------------*/

        let disableBodyScroll = (function () {

            let _selector = false,
                _element = false,
                _clientY;

            if (!Element.prototype.matches)
                Element.prototype.matches = Element.prototype.msMatchesSelector ||
                    Element.prototype.webkitMatchesSelector;

            if (!Element.prototype.closest)
                Element.prototype.closest = function (s) {
                    let ancestor = this;
                    if (!document.documentElement.contains(el)) return null;
                    do {
                        if (ancestor.matches(s)) return ancestor;
                        ancestor = ancestor.parentElement;
                    } while (ancestor !== null);
                    return el;
                };

            let preventBodyScroll = function (event) {
                if (false === _element || !event.target.closest(_selector)) {
                    event.preventDefault();
                }
            };

            let captureClientY = function (event) {

                if (event.targetTouches.length === 1) {
                    _clientY = event.targetTouches[0].clientY;
                }
            };

            let preventOverscroll = function (event) {

                if (event.targetTouches.length !== 1) {
                    return;
                }

                let clientY = event.targetTouches[0].clientY - _clientY;

                if (_element.scrollTop === 0 && clientY > 0) {
                    event.preventDefault();
                }

                if ((_element.scrollHeight - _element.scrollTop <= _element.clientHeight) && clientY < 0) {
                    event.preventDefault();
                }

            };

            return function (allow, selector) {
                if (typeof selector !== "undefined") {
                    _selector = selector;
                    _element = document.querySelector(selector);
                }

                if (true === allow) {
                    if (false !== _element) {
                        _element.addEventListener('touchstart', captureClientY, false);
                        _element.addEventListener('touchmove', preventOverscroll, false);
                    }
                    document.body.addEventListener("touchmove", preventBodyScroll, false);
                } else {
                    if (false !== _element) {
                        _element.removeEventListener('touchstart', captureClientY, false);
                        _element.removeEventListener('touchmove', preventOverscroll, false);
                    }
                    document.body.removeEventListener("touchmove", preventBodyScroll, false);
                }
            };

        })();

        // scroll

        (() => {

            let scroll = window.requestAnimationFrame;

            function scrollWindow() {

                let st = $(window).scrollTop();

                if (st > 10) {

                    header.addClass('header-dark');

                } else {

                    header.removeClass('header-dark');

                }

                scroll(scrollWindow);

            }

            scrollWindow();

        })();

        // disable element for some time

        function disableElement(element, time) {

            element.addClass('disabled');

            setTimeout(function () {

                element.removeClass('disabled');

            }, time);

        }

        headerBtn.click(function () {

            if ($(this).hasClass('btn-transform')) {

                $(this).removeClass('btn-transform');
                disableElement(headerBtn, 500);
                header.removeAttr('style');
                $('html').removeClass('no-scroll');
                $('body').removeAttr('style');
                disableBodyScroll(false, '.js-header-menu');
                headerMenu.removeClass('show-menu');

            } else {

                $(this).addClass('btn-transform');
                disableElement(headerBtn, 1000);
                header.css('padding-right', scrollWidth);
                $('html').addClass("no-scroll");
                $('body').css('padding-right', scrollWidth);
                disableBodyScroll(true, '.js-header-menu');
                headerMenu.addClass('show-menu');

            }

        });


    })();

});


// WEBPACK FOOTER //
// ./scripts/header.js